module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Bold.2e277273f3e831fac28e8a55a8c0fa24.eot";